import { render } from "./userProfile.vue?vue&type=template&id=735aa62c&scoped=true"
import script from "./userProfile.vue?vue&type=script&lang=js"
export * from "./userProfile.vue?vue&type=script&lang=js"

import "./userProfile.vue?vue&type=style&index=0&id=735aa62c&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/sb.web.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-735aa62c"]])

export default __exports__